import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5d8aabda = () => interopDefault(import('../../../src/pages/account.vue' /* webpackChunkName: "pages/account" */))
const _021caf9f = () => interopDefault(import('../../../src/pages/connect-wallet.vue' /* webpackChunkName: "pages/connect-wallet" */))
const _30f4bd62 = () => interopDefault(import('../../../src/pages/contact-support.vue' /* webpackChunkName: "pages/contact-support" */))
const _00b1b227 = () => interopDefault(import('../../../src/pages/contact-support-music.vue' /* webpackChunkName: "pages/contact-support-music" */))
const _3e26b082 = () => interopDefault(import('../../../src/pages/create-account.vue' /* webpackChunkName: "pages/create-account" */))
const _7c4932f1 = () => interopDefault(import('../../../src/pages/environmentalimpact.vue' /* webpackChunkName: "pages/environmentalimpact" */))
const _41ffb889 = () => interopDefault(import('../../../src/pages/get-gala.vue' /* webpackChunkName: "pages/get-gala" */))
const _33b6564a = () => interopDefault(import('../../../src/pages/loggedin.vue' /* webpackChunkName: "pages/loggedin" */))
const _c0bf1754 = () => interopDefault(import('../../../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _41cc9bcf = () => interopDefault(import('../../../src/pages/my-collection/index.vue' /* webpackChunkName: "pages/my-collection/index" */))
const _fb50732c = () => interopDefault(import('../../../src/pages/my-wallet/index.vue' /* webpackChunkName: "pages/my-wallet/index" */))
const _457c8ba1 = () => interopDefault(import('../../../src/pages/nodes/index.vue' /* webpackChunkName: "pages/nodes/index" */))
const _2ed69d55 = () => interopDefault(import('../../../src/pages/notifications.vue' /* webpackChunkName: "pages/notifications" */))
const _65c8d662 = () => interopDefault(import('../../../src/pages/pkce-callback.vue' /* webpackChunkName: "pages/pkce-callback" */))
const _7d283a0c = () => interopDefault(import('../../../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _a0d98674 = () => interopDefault(import('../../../src/pages/register.vue' /* webpackChunkName: "pages/register" */))
const _74740e65 = () => interopDefault(import('../../../src/pages/registered.vue' /* webpackChunkName: "pages/registered" */))
const _be6ff90a = () => interopDefault(import('../../../src/pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _37bbb697 = () => interopDefault(import('../../../src/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _2e115ba9 = () => interopDefault(import('../../../src/pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _880fa76e = () => interopDefault(import('../../../src/pages/upgrade.vue' /* webpackChunkName: "pages/upgrade" */))
const _188ec12a = () => interopDefault(import('../../../src/pages/verify-email.vue' /* webpackChunkName: "pages/verify-email" */))
const _44692868 = () => interopDefault(import('../../../src/pages/verify-ip.vue' /* webpackChunkName: "pages/verify-ip" */))
const _7c4c7ed4 = () => interopDefault(import('../../../src/pages/external/register.vue' /* webpackChunkName: "pages/external/register" */))
const _944f66c4 = () => interopDefault(import('../../../src/pages/landing/common-ground.vue' /* webpackChunkName: "pages/landing/common-ground" */))
const _1310c3dc = () => interopDefault(import('../../../src/pages/nodes/my-node.vue' /* webpackChunkName: "pages/nodes/my-node" */))
const _e69b8d8e = () => interopDefault(import('../../../src/pages/simplex/order-history.vue' /* webpackChunkName: "pages/simplex/order-history" */))
const _498c8be8 = () => interopDefault(import('../../../src/pages/my-collection/nfts/item.vue' /* webpackChunkName: "pages/my-collection/nfts/item" */))
const _4cb96482 = () => interopDefault(import('../../../src/pages/collections/buy-item/_id.vue' /* webpackChunkName: "pages/collections/buy-item/_id" */))
const _5649398c = () => interopDefault(import('../../../src/pages/lookup/ref/_id.vue' /* webpackChunkName: "pages/lookup/ref/_id" */))
const _93f14e50 = () => interopDefault(import('../../../src/pages/my-collection/nfts/_category.vue' /* webpackChunkName: "pages/my-collection/nfts/_category" */))
const _e9c8d462 = () => interopDefault(import('../../../src/pages/my-wallet/_symbol.vue' /* webpackChunkName: "pages/my-wallet/_symbol" */))
const _c4385770 = () => interopDefault(import('../../../src/pages/collections/_name/your-items.vue' /* webpackChunkName: "pages/collections/_name/your-items" */))
const _a0c84ba0 = () => interopDefault(import('../../../src/pages/nodes/_name/buy.vue' /* webpackChunkName: "pages/nodes/_name/buy" */))
const _540e5d82 = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ef3faa2a = () => interopDefault(import('../../../src/pages/_schema/_slug/index.vue' /* webpackChunkName: "pages/_schema/_slug/index" */))
const _c7dd20da = () => interopDefault(import('../../../src/pages/_schema/_slug/create-account.vue' /* webpackChunkName: "pages/_schema/_slug/create-account" */))
const _3b4bdf4f = () => interopDefault(import('../../../src/pages/_schema/_slug/signup.vue' /* webpackChunkName: "pages/_schema/_slug/signup" */))
const _449bff55 = () => interopDefault(import('../../../src/pages/_schema/_slug/thank-you.vue' /* webpackChunkName: "pages/_schema/_slug/thank-you" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _5d8aabda,
    name: "account"
  }, {
    path: "/connect-wallet",
    component: _021caf9f,
    name: "connect-wallet"
  }, {
    path: "/contact-support",
    component: _30f4bd62,
    name: "contact-support"
  }, {
    path: "/contact-support-music",
    component: _00b1b227,
    name: "contact-support-music"
  }, {
    path: "/create-account",
    component: _3e26b082,
    alias: "/create-account/*",
    name: "create-account"
  }, {
    path: "/environmentalimpact",
    component: _7c4932f1,
    name: "environmentalimpact"
  }, {
    path: "/get-gala",
    component: _41ffb889,
    name: "get-gala"
  }, {
    path: "/loggedin",
    component: _33b6564a,
    name: "loggedin"
  }, {
    path: "/login",
    component: _c0bf1754,
    name: "login"
  }, {
    path: "/my-collection",
    component: _41cc9bcf,
    name: "my-collection"
  }, {
    path: "/my-wallet",
    component: _fb50732c,
    name: "my-wallet"
  }, {
    path: "/nodes",
    component: _457c8ba1,
    name: "nodes"
  }, {
    path: "/notifications",
    component: _2ed69d55,
    name: "notifications"
  }, {
    path: "/pkce-callback",
    component: _65c8d662,
    name: "pkce-callback"
  }, {
    path: "/privacy-policy",
    component: _7d283a0c,
    name: "privacy-policy"
  }, {
    path: "/register",
    component: _a0d98674,
    name: "register"
  }, {
    path: "/registered",
    component: _74740e65,
    name: "registered"
  }, {
    path: "/signup",
    component: _be6ff90a,
    alias: "/signup/*",
    name: "signup"
  }, {
    path: "/terms-and-conditions",
    component: _37bbb697,
    name: "terms-and-conditions"
  }, {
    path: "/thank-you",
    component: _2e115ba9,
    name: "thank-you"
  }, {
    path: "/upgrade",
    component: _880fa76e,
    name: "upgrade"
  }, {
    path: "/verify-email",
    component: _188ec12a,
    name: "verify-email"
  }, {
    path: "/verify-ip",
    component: _44692868,
    name: "verify-ip"
  }, {
    path: "/external/register",
    component: _7c4c7ed4,
    name: "external-register"
  }, {
    path: "/landing/common-ground",
    component: _944f66c4,
    name: "landing-common-ground"
  }, {
    path: "/nodes/my-node",
    component: _1310c3dc,
    name: "nodes-my-node"
  }, {
    path: "/simplex/order-history",
    component: _e69b8d8e,
    name: "simplex-order-history"
  }, {
    path: "/my-collection/nfts/item",
    component: _498c8be8,
    name: "my-collection-nfts-item"
  }, {
    path: "/collections/buy-item/:id?",
    component: _4cb96482,
    name: "collections-buy-item-id"
  }, {
    path: "/lookup/ref/:id?",
    component: _5649398c,
    name: "lookup-ref-id"
  }, {
    path: "/my-collection/nfts/:category",
    component: _93f14e50,
    name: "my-collection-nfts-category"
  }, {
    path: "/my-wallet/:symbol?",
    component: _e9c8d462,
    name: "my-wallet-symbol"
  }, {
    path: "/collections/:name?/your-items",
    component: _c4385770,
    name: "collections-name-your-items"
  }, {
    path: "/nodes/:name/buy",
    component: _a0c84ba0,
    name: "nodes-name-buy"
  }, {
    path: "/",
    component: _540e5d82,
    name: "index"
  }, {
    path: "/:schema/:slug",
    component: _ef3faa2a,
    name: "schema-slug"
  }, {
    path: "/:schema/:slug?/create-account",
    component: _c7dd20da,
    alias: "/:schema/:slug?/create-account/*",
    name: "schema-slug-create-account"
  }, {
    path: "/:schema/:slug?/signup",
    component: _3b4bdf4f,
    alias: "/:schema/:slug?/signup/*",
    name: "schema-slug-signup"
  }, {
    path: "/:schema/:slug?/thank-you",
    component: _449bff55,
    name: "schema-slug-thank-you"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
